import { Box, Button, Grid, IconButton, Stack } from '@mui/material';
import * as React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import CustomTextField from '../Forms/CustomTextField';
import { Form, Formik } from 'formik';
import { validationDialogTelefonoNo } from './ValidationsFormYup';
import { handleMaxLength } from '../Utils/FieldValidationFuctions';


export default function FormDialogNoEncuentroAuto(props) {

  const [botonActivo, setBotonActivo] = React.useState(false);
  const handleClickModal = () => {
    props.handleClose();
  }

  const handleAyudaNo = (values, setSubmitting) => {
    props.handleClose();
  }

  const handleOnchange = (event) => {
    let numero = event;
    let longituNumero = (numero.toString().length);
    if (longituNumero === '' || longituNumero < 10) {
      setBotonActivo(false);
    } else {
      setBotonActivo(true);
    }
  }



  return (
    <>
      <Formik
        validateOnChange={true}
        initialValues={{
          telefonoNo: '',

        }}
        onSubmit={(values, { setSubmitting }) => {
          setSubmitting(true);
          handleAyudaNo(values, setSubmitting);
        }}
        validationSchema={validationDialogTelefonoNo}>
        {({ values, submitForm, setFieldValue, handleChange, errors, isSubmitting, setFieldError, touched, setFieldTouched, }) => (
          <Form>
            <IconButton
              aria-label="close"
              onClick={handleClickModal}
              sx={{
                position: 'absolute',
                right: 8,
                top: 0,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
            <Grid container direction="column" justifyContent="center" alignItems="center">
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="modal-individual-padding">
                <Stack
                  direction="column"
                  justifyContent="center"
                  alignItems="center"
                  spacing={2}
                >
                  <br />
                  <span className='modal-titulo'>&iquest;No esta tu veh&iacute;culo? </span>
                  <span className='modal-text'>Nos puedes marcar</span>
                  <span className='modal-text'>55442 46837</span>
                  {/*<span className='modal-text'>o te podemos marcar</span>

                  <Box
                    component="form"
                    sx={{
                      '& > :not(style)': { m: 1, width: '25ch' },
                    }}
                    noValidate
                    autoComplete="off"
                  >

                    <CustomTextField id="telefonoNo" name="telefonoNo" type="number" placeholder="Tel&eacute;fono/Celular"
                      onChange={(event) => { handleMaxLength(event, setFieldValue, "telefonoNo", 10); handleOnchange(event.target.value) }}
                    />
                  </Box>

                  <Button
                    variant="contained"
                    onClick={submitForm}
                    disabled={!botonActivo}
                    style={{ textTransform: 'capitalize' }}
                  >
                    M&aacute;rcame
                  </Button>*/}

                </Stack>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </>
  );
}